import { render, staticRenderFns } from "./companyArchives.vue?vue&type=template&id=27b28cf4&scoped=true&"
import script from "./companyArchives.vue?vue&type=script&lang=js&"
export * from "./companyArchives.vue?vue&type=script&lang=js&"
import style0 from "./companyArchives.vue?vue&type=style&index=0&id=27b28cf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b28cf4",
  null
  
)

export default component.exports